const nonResidentResources = {
  en: {
    nonResident: {
      title: 'Medical insurance for non-residents',
      calculator: 'Insurance Calculator',
      sum: 'Sum insured',
      period: 'Term of insurance',
      select1: 'up to 1 month inclusive',
      select2: 'from 1 to 2 months inclusive',
      select3: 'from 2 to 3 months inclusive',
      select4: 'from 3 to 4 months inclusive',
      select5: 'from 4 to 5 months inclusive',
      select6: 'from 5 to 6 months inclusive',
      button: 'Calculate',
      'description.title': 'Description',
      'description.text1':
        'In accordance with the requirement of the Law of the Republic of Kazakhstan “On Population Migration”: foreign workers, business immigrants, seasonal foreign workers and labor migrants, in order to fulfill the conditions of entry and stay in the territory of the Republic of Kazakhstan, are required to have medical insurance.',
      'description.text2':
        'Alatau City Garant Insurance Company offers a non-resident sickness insurance service - "Foreigner" (health insurance), this program covers the cost of medical services in case of sudden illness or repatriation in case of death.',
      'description.text3': 'Insurance program',
      'description.text4': 'Name of medical services',
      'description.text5':
        'The volume of medical services provided within the sum insured',
      'description.text6': '24/7 dispatch service',
      'description.text7': 'call an ambulance;',
      'description.text8':
        'recommendations of the doctor - coordinator until the arrival of the ambulance;',
      'description.text9':
        'information services on the insurance program, limits and expenses of the Insured.',
      'description.text10': 'Emergency',
      'description.text11':
        'Organization of emergency medical assistance to the Insured in the event of conditions threatening life and health (emergency conditions), by a brigade of the state ambulance service through the Assistance Call-Center. Departure of the ambulance brigade is carried out within the administrative boundaries of cities and regional centers: ',
      'description.text12': 'departure of the ambulance team;',
      'description.text13':
        'carrying out the necessary medical and diagnostic measures;',
      'description.text14': 'the use of medicines and medical equipment;',
      'description.text15':
        'hospitalization of the Insured in a specialized medical facility.',
      'description.text16': 'Repatriation',
      'description.text17':
        'Expenses for repatriation of the body of the Insured to the country whose citizenship the Insured had during his lifetime, namely:',
      'description.text18':
        'expenses associated with the organization, storage and transportation of the remains of the Insured to the nearest international airport to the place of burial in the country whose citizenship the Insured had during his lifetime.',
      'description.text19': 'The provision of services is provided by ',
      'description.text20': 'the Service Company "SBS MED ASSISTANCE" LLP.',
      'description.text21': 'Insurance case:',
      'description.text22':
        'Upon the occurrence of any event that has signs of an insured event and / or the consequence of which may be the occurrence of an insured event, that is, before applying for a medical or other service specified in the insurance contract, the insured or other interested person must immediately, but no later than 24 hours from the moment of its occurrence, contact the Assistance by phone numbers specified in the insurance contract (insurance policy) and report:',
      'description.text23': 'last name, first name of the insured person;',
      'description.text24':
        'the number and validity period of the insurance contract;',
      'description.text25': 'location of the insured person, contact numbers;',
      'description.text26': 'what happened and what services he needs.',
      'description.text27':
        'After receiving instructions from Assistance, the insured must act in strict accordance with the instructions received.',
      'description.text28':
        'In the event of an insured event stipulated by the insurance contract, Assistance, on behalf of the insurer, ensures the provision of services to the insured within the sum insured established by the insurance contract.',
      'description.text29':
        'Timely application to Assistance is a prerequisite for the implementation of the insurance payment.',
      'description.text30': 'Contacts for treatment:',
      'description.text31':
        'The provision of services is provided by the Service Company  ',
      'description.text32': '"SBS MED ASSISTANCE" LLP.',
      'description.text33': '24/7 COORDINATION CENTER',
      'description.text34': 'MULTI-CHANNEL TEL: 8 (727)  233-03-00',
      'description.text35': 'mob.: 8 701 752  15 05, 8 701 752 15 04',
    },
  },
  kz: {
    nonResident: {
      title: 'Бейрезиденттерді медициналық сақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      sum: 'Сақтандыру сомасы',
      period: 'Сақтандыру мерзімі',
      select1: '1 айға дейін қоса алғанда',
      select2: '1 айдан 2 айға дейін қоса алғанда',
      select3: '2 айдан 3 айға дейін қоса алғанда',
      select4: '3 айдан 4 айға дейін қоса алғанда',
      select5: '4 айдан 5 айға дейін қоса алғанда',
      select6: '5 айдан 6 айға дейін қоса алғанда',
      button: 'Есептеу',
      'description.title': 'Сипаттамасы',
      'description.text1':
        '"Халықтың көші-қоны туралы" ҚР Заңының талаптарына сәйкес: шетелдік қызметкерлер, бизнес-көшіп келушілер, маусымдық шетелдік қызметкерлер және еңбек мигранттары Қазақстан Республикасының аумағында келу және болу шарттарын орындау үшін медициналық сақтандыруға міндетті.',
      'description.text2':
        'Страховая компания «Alatau City Garant» сақтандыру компаниясы бейрезиденттер ауырған жағдайда – «Шетелдік» (медициналық сақтандыру) сақтандыру қызметін ұсынады, бұл бағдарлама кенеттен ауырған жағдайда медициналық қызметтерге немесе қайтыс болған жағдайда репатриациялауға арналған шығыстарды жабады.',
      'description.text3': 'Сақтандыру бағдарламасы',
      'description.text4': 'Медициналық қызметтердің атауы',
      'description.text5':
        'Сақтандыру сомасы шегінде көрсетілген медициналық қызметтердің көлемі',
      'description.text6': 'Тәулік бойы диспетчерлік қызмет',
      'description.text7': 'жедел жәрдем шақыру;',
      'description.text8':
        'жедел медициналық жәрдем келгенге дейін үйлестіруші дәрігердің ұсынымдары;',
      'description.text9':
        'сақтандыру бағдарламасы, сақтандырылушының лимиттері мен шығыстары бойынша ақпараттық қызметтер.',
      'description.text10': 'Жедел медициналық қызмет',
      'description.text11':
        'Өмірге және денсаулыққа қауіп төндіретін жағдайлар (шұғыл жағдайлар) туындаған кезде Сақтандырылған тұлғаға шұғыл медициналық көмекті мемлекеттік жедел жәрдем қызметінің бригадасы Ассистанстың Call-Center арқылы ұйымдастырады. Жедел медициналық жәрдем бригадасының шығуы қалалар мен облыс орталықтарының әкімшілік шекаралары шегінде жүзеге асырылады: ',
      'description.text12': 'жедел медициналық жәрдем бригадасының шығуы;',
      'description.text13':
        'қажетті емдеу-диагностикалық іс-шараларды жүргізу;',
      'description.text14':
        'дәрілік препараттар мен медициналық аппаратураны қолдану;',
      'description.text15':
        'сақтандырылғандарды мамандандырылған медициналық мекемеге жатқызу.',
      'description.text16': 'Репатриация',
      'description.text17':
        'Сақтандырылған адамның денесін тірі кезінде азаматтығы бар елге қайтаруға арналған шығыстар, атап айтқанда:',
      'description.text18':
        'Сақтандырылған адамның қалдықтарын Сақтандырылған адамның тірі кезінде азаматтығы болған елдегі жерленген жеріне жақын халықаралық әуежайға дейін ұйымдастыруға, сақтауға және тасымалдауға байланысты шығыстар.',
      'description.text19': 'Қызмет көрсетуді  ',
      'description.text20':
        '«SBS MED АССИСТАНС» ЖШС Сервистік Компаниясы қамтамасыз етеді.',
      'description.text21': 'Сақтандыру жағдайы:',
      'description.text22':
        'Сақтандыру жағдайының белгілері бар және/немесе оның салдары сақтандыру жағдайының басталуы болуы мүмкін кез келген оқиға басталған кезде, яғни сақтандыру шартында көрсетілген медициналық немесе өзге де қызметке жүгінгенге дейін Сақтандырылған адам не өзге мүдделі тұлға дереу, бірақ ол басталған сәттен бастап 24 сағаттан кешіктірмей Ассистансқа Сақтандыру шартында (сақтандыру полисінде) көрсетілген телефон арқылы хабарласып, келесілерді  хабарлау керек:',
      'description.text23': 'сақтандырылған тұлғаның тегі, аты;',
      'description.text24': 'сақтандыру шартының нөмірі мен қолданылу мерзімі;',
      'description.text25':
        'сақтандырылған тұлғаның орналасқан жері, байланыс телефондары;',
      'description.text26': 'не болғанын және оған қандай қызметтер қажет.',
      'description.text27':
        'Ассистанстан нұсқаулар алғаннан кейін сақтанушы алынған нұсқауларға сәйкес қатаң түрде әрекет етуі керек.',
      'description.text28':
        'Сақтандыру шартында көзделген сақтандыру жағдайы басталған кезде сақтандырушының атынан Ассистанс сақтандырылғанға сақтандыру шартында белгіленген сақтандыру сомасы шегінде қызметтер көрсетуді қамтамасыз етеді.',
      'description.text29':
        'Ассистансқа уақтылы жүгіну сақтандыру төлемін жүзеге асырудың міндетті шарты болып табылады.',
      'description.text30': 'Жүгінуге арналған байланыстар:',
      'description.text31': 'Қызмет көрсетуді',
      'description.text32': '«SBS MED АССИСТАНС» ЖШС',
      'description.text322': ' Сервистік Компаниясы қамтамасыз етеді.',
      'description.text33': 'ТӘУЛІК БОЙЫ ҮЙЛЕСТІРУ ОРТАЛЫҒЫ',
      'description.text34': 'КӨП АРНАЛЫ ТЕЛ.: 8 (727)  233-03-00',
      'description.text35': 'ұялы тел.: 8 701 752  15 05, 8 701 752 15 04',
    },
  },
  ru: {
    nonResident: {
      title: 'Медицинское страхование нерезидентов',
      calculator: 'Калькулятор страхования',
      sum: 'Сумма страхования',
      period: 'Срок страхования',
      select1: 'до 1 месяца включительно',
      select2: 'от 1 до 2 месяцев включительно',
      select3: 'от 2 до 3 месяцев включительно',
      select4: 'от 3 до 4 месяцев включительно',
      select5: 'от 4 до 5 месяцев включительно',
      select6: 'от 5 до 6 месяцев включительно',
      button: 'Рассчитать',
      'description.title': 'Описание',
      'description.text1':
        'В соответствии с требованием Закона РК «О миграции населения»: иностранные работники, бизнес-иммигранты, сезонные иностранные работники и трудовые мигранты, для выполнения на территории Республики Казахстан условий въезда и пребывания, обязаны иметь медицинскую страховку.',
      'description.text2':
        'Страховая компания «Alatau City Garant» предлагает услугу страхования на случай болезни нерезидентов - «Иностранец» (медицинское страхование), данная программа покрывает расходы на медицинские услуги в случае внезапного заболевания либо репатриацию в случае смерти.',
      'description.text3': 'Программа страхования',
      'description.text4': 'Наименование медицинских услуг',
      'description.text5':
        'Объем предоставленных медицинских услуг в пределах страховой суммы',
      'description.text6': 'Круглосуточная диспетчерская служба',
      'description.text7': 'вызов скорой помощи;',
      'description.text8':
        'рекомендации врача – координатора до момента приезда скорой медицинской помощи;',
      'description.text9':
        'информационные услуги по страховой программе, лимитам и расходам Застрахованного.',
      'description.text10': 'Скорая медицинская помощь',
      'description.text11':
        'Организация экстренной медицинской помощи Застрахованному при возникновении угрожающих жизни и здоровью состояний (экстренные состояния), бригадой государственной службы скорой помощи через Call-Center Ассистанса. Выезд бригады Скорой медицинской помощи осуществляется в пределах административных границ городов и областных центров: ',
      'description.text12': 'выезд бригады скорой медицинской помощи;',
      'description.text13':
        'проведение необходимых лечебно-диагностических мероприятий;',
      'description.text14':
        'применение лекарственных препаратов и медицинской аппаратуры;',
      'description.text15':
        'госпитализация Застрахованного в специализированное медицинское учреждение.',
      'description.text16': 'Репатриация',
      'description.text17':
        'Расходы на репатриацию тела Застрахованного в страну, гражданство которой имел Застрахованный при жизни, а именно:',
      'description.text18':
        'расходы, связанные с организацией, хранением и транспортировкой останков Застрахованного до ближайшего к месту захоронения международного аэропорта в стране, гражданство которой Застрахованный имел при жизни.',
      'description.text19': 'Оказание услуг обеспечивает Сервисная Компания  ',
      'description.text20': 'TOO «SBS MED АССИСТАНС».',
      'description.text21': 'Страховой случай:',
      'description.text22':
        'При наступлении любого события, имеющего признаки страхового случая и/или последствием которого может быть наступление страхового случая, то есть до обращения за медицинской или иной услугой, указанной в договоре страхования, застрахованный либо иное заинтересованное лицо, обязан незамедлительно, но не позднее 24 часов с момента его наступления, связаться с Ассистансом по телефонам, указанным в договоре страхования (страховом полисе), и сообщить:',
      'description.text23': 'фамилию, имя застрахованного;',
      'description.text24': 'номер и срок действия договора страхования;',
      'description.text25':
        'местонахождение застрахованного, контактные телефоны;',
      'description.text26': 'что произошло и какие услуги ему требуются.',
      'description.text27':
        'После получения указаний от Ассистанса, застрахованный должен действовать в строгом соответствии с полученными указаниями.',
      'description.text28':
        'При наступлении страхового случая, предусмотренного договором страхования, Ассистанс от имени страховщика обеспечивает оказание застрахованному услуг в пределах страховой суммы, установленной договором страхования.',
      'description.text29':
        'Своевременное обращение в Ассистанс является обязательным условием осуществления страховой выплаты.',
      'description.text30': 'Контакты для обращения:',
      'description.text31': 'Оказание услуг обеспечивает Сервисная Компания',
      'description.text32': 'TOO «SBS MED АССИСТАНС».',
      'description.text33': 'КРУГЛОСУТОЧНЫЙ  КООРДИНАЦИОННЫЙ  ЦЕНТР',
      'description.text34': 'МНОГОКАНАЛЬНЫЙ ТЕЛ.: 8 (727)  233-03-00',
      'description.text35': 'сот.: 8 701 752  15 05, 8 701 752 15 04',
    },
  },
};

export default nonResidentResources;
